export default "__VITE_ASSET__BoscguV7__"